"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import Script from "next/script";
import { IBM_Plex_Sans, IBM_Plex_Serif } from "next/font/google";
import "./styles/globals.css";
import Navbar from "../src/components/home/Navbar";
import ClientFooter from "../src/components/home/ClientFooter";
import programsDataJson from "../src/data/mentorship-programs.json";
import workshopsDataJson from "../src/data/workshops.json";

const ibmPlexSans = IBM_Plex_Sans({
  weight: ["400", "500", "600", "700"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-ibm-plex-sans",
});

const ibmPlexSerif = IBM_Plex_Serif({
  weight: ["400", "500", "600", "700"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-ibm-plex-serif",
});

export default function MyApp({ Component, pageProps }) {
  const [programs, setPrograms] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [navDataLoaded, setNavDataLoaded] = useState(false);
  const router = useRouter();

  // Check if current route should hide navbar and footer
  const shouldHideLayout = router.pathname === "/newsletter/unsubscribe";

  useEffect(() => {
    const fetchNavData = async () => {
      try {
        setPrograms(programsDataJson || []);
        setWorkshops(workshopsDataJson || []);
      } catch (error) {
        console.error("Error fetching navbar data:", error);
        // Keep empty arrays as fallback
        setPrograms([]);
        setWorkshops([]);
      } finally {
        setNavDataLoaded(true);
      }
    };

    fetchNavData();
  }, []);

  return (
    <>
      <Head>
        {/* Primary favicon for Google */}
        <link rel="icon" type="image/png" sizes="96x96" href="/favicon.png" />

        {/* Fallback for older systems */}
        <link rel="icon" href="/favicon.ico" />

        <title>GrowthSchool – Become the Top 1%</title>
        <meta
          name="description"
          content="Master the skills you need to become the top 1% in your field at GrowthSchool."
        />
      </Head>

      {/* Google Tag Manager */}
      <Script
        id="google-tag-manager"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5GL6KVS');
          `,
        }}
      />

      {/* Microsoft Clarity */}
      <Script
        id="microsoft-clarity"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "wfju72i97m");
          `,
        }}
      />

      <div
        className={`antialiased ${ibmPlexSans.variable} ${ibmPlexSerif.variable}`}
      >
        {!shouldHideLayout && (
          <Navbar programs={programs} workshops={workshops} />
        )}
        <Component {...pageProps} />
        {!shouldHideLayout && <ClientFooter />}
      </div>
    </>
  );
}
